import { createAction } from 'redux-act';

export const PREFERENCES_SET_LOCALE = createAction('PREFERENCES_SET_LOCALE');
export const PREFERENCES_SET_MAP_OPTIONS = createAction(
  'PREFERENCES_SET_MAP_OPTIONS'
);
export const PREFERENCES_SET_MAP_STYLE = createAction(
  'PREFERENCES_SET_MAP_STYLE'
);
export const PREFERENCES_CLEAR_DATA_LOGOUT = createAction(
  'PREFERENCES_CLEAR_DATA_LOGOUT'
);

export const PREFERENCES_SHOW_FOOTER = createAction('PREFERENCES_SHOW_FOOTER');
export const PREFERENCES_HIDE_FOOTER = createAction('PREFERENCES_HIDE_FOOTER');

export const setUserLocale = (locale) => (dispatch) => {
  return dispatch(PREFERENCES_SET_LOCALE({ locale }));
};

export const setMapOptions = ({ center, zoom }) => (dispatch) => {
  return dispatch(PREFERENCES_SET_MAP_OPTIONS({ center, zoom }));
};

export const setMapStyle = ({ style }) => (dispatch) => {
  return dispatch(PREFERENCES_SET_MAP_STYLE(style));
};

export const clearPreferencesDataLogout = () => (dispatch) => {
  return dispatch(PREFERENCES_CLEAR_DATA_LOGOUT());
};

export const showFooter = () => (dispatch) => {
  return dispatch(PREFERENCES_SHOW_FOOTER());
};

export const hideFooter = () => (dispatch) => {
  return dispatch(PREFERENCES_HIDE_FOOTER());
};
